import { render, staticRenderFns } from "./ClientsAccessElement.vue?vue&type=template&id=23d095ce&scoped=true"
import script from "./ClientsAccessElement.vue?vue&type=script&lang=js"
export * from "./ClientsAccessElement.vue?vue&type=script&lang=js"
import style0 from "./ClientsAccessElement.vue?vue&type=style&index=0&id=23d095ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d095ce",
  null
  
)

export default component.exports